export default __webpack_public_path__ + "static/media/whiteLogo.733b86c7.svg";